import * as React from "react";

import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { Stack, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/system";

export default function HomeDocument() {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery("(max-width:768px)");

  return (
    <Box
      id="Home_document"
      sx={{
        width: "100%",
      }}
    >
      <Typography
        // variant="h1"
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "2.5rem",
          margin: "2%",
          [theme.breakpoints.down("sm")]: {
            fontSize: "2rem",
          },
        }}
      >
        Document
      </Typography>
      <Typography
        variant="body1"
        sx={{
          display: "flex",
          justifyContent: "center",
          fontSize: "1.4rem",
          fontFamily: "sans-serif",
          margin: "0 15% 5% 15%",
          lineHeight: 1.5,
          letterSpacing: 0.2,
          textAlign: "center",
          [theme.breakpoints.down("sm")]: {
            margin: "0 5% 5% 5%",
            fontSize: "1.2rem",
          },
        }}
      >
        Get a Balance Sheet, Statement of Profit & Loss, Financial Reports, MCA
        Details, Company Financials, Financial Ratios, Ownership Structure,
        Investments and Other relevant financial items.
      </Typography>
      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          pb: { xs: 8, sm: 12 },
        }}
      >
        <Stack spacing={2} useFlexGap>
          {/* <Typography
            component="h1"
            variant="h1"
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              textAlign: "center",
            }}
          ></Typography> */}

          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: "center",
            }}
          >
            <img
              src={require("../img/document_part_1.png")}
              alt="Description of the image"
              style={{
                margin: "-5%",
                width: "70%",
                height: "auto",
                maxWidth: "700px",
              }}
            />
            <Box
              sx={{
                textAlign: "center",
                justifyContent: "center",
                alignItems: "center",
                flex: "1",
                mt: isSmallScreen ? 3 : 0,
              }}
            >
              <Typography
                component="h4"
                variant="h4"
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                  alignItems: "center",
                  justifyContent: "center",
                  textAlign: "center",
                  [theme.breakpoints.down("sm")]: {
                    flexDirection: "column",
                    textAlign: "center",
                  },
                }}
              >
                {/* An Easy to use, multi-asset portfolio&nbsp; */}
                <Typography
                  component="span"
                  variant="h4"
                  sx={{
                    color:
                      theme.palette.mode === "light"
                        ? "primary.main"
                        : "primary.light",
                  }}
                >
                  {/* Maker */}
                </Typography>
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: "1.2rem",
                  fontFamily: "sans-serif",
                  margin: "4% 12%",
                  lineHeight: 1.5,
                  letterSpacing: 0.2,
                  textAlign: "left",
                  [theme.breakpoints.down("sm")]: {
                    margin: "2% 2%",
                    fontSize: "1.2rem",
                  },
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: "1.2rem",
                  }}
                >
                 Use our Reports for :-
                </Typography>
                <ul
                  style={{
                    listStyleType: "disc", // Standard bullet format
                    paddingLeft: "1.5rem", // Indentation for bullets
                    marginTop: "1rem",
                    textAlign: "left", // Align bullets to the left
                  }}
                >
                  <li style={{ marginBottom: "0.75rem" }}>
                    Investing In A Business
                  </li>
                  <li style={{ marginBottom: "0.75rem" }}>
                    Taking A Franchise
                  </li>
                  <li style={{ marginBottom: "0.75rem" }}>
                    Partnering With A Brand
                  </li>
                  <li style={{ marginBottom: "0.75rem" }}>
                    Getting Into A Joint Venture
                  </li>
                  <li style={{ marginBottom: "0.75rem" }}>
                    Deciding Business Options
                  </li>
                </ul>
              </Typography>
            </Box>
          </Box>
        </Stack>
      </Container>
    </Box>
  );
}
